

























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* components */
import FieldItem from '@/app/components/Field/List/FieldItem.vue'
/* module */
import Session from '@/app/module/session'
import { routerPath } from '@/app/model/store/domain/const'

@Component({
  components: {
    FieldItem
  }
})
export default class FieldList extends Vue {
  private fieldId: string = ''
  private displayFieldData: Array<{[key:string]: string}> = []
  private detailsData: any[] = []

  @Prop() private fieldData!: Array<{[key:string]: string}>
  @Prop() private id!: number
  @Prop() private flag!: boolean

  /* computed */
  private get fieldChoiceState (): string {
    return this.$store.state.fieldChoiceState.id
  }
  private get fieldDataState (): number {
    return this.$store.state.fieldState.fieldData
  }
  private get props (): any {
    return this.fieldData
  }
  private get getDetailsData (): boolean {
    return this.$store.state.fieldChoiceState.chooseFlag
  }

  @Watch('getDetailsData')
  private changeList (flag: boolean) {
    if (!flag) {
      /* アコーディオンの中身が開き切っていないとscrollIntoViewが上手く行かないためsetTimeout */
      setTimeout(this.scrollIntoView, 100)
    }
  }
  private scrollIntoView () {
    let el: any = document.getElementById(this.$store.state.fieldChoiceState.id)
    if (el !== null && el !== undefined) {
      el.scrollIntoView({ behavior: 'instant' })
    }
  }
  @Watch('fieldChoiceState')
  private isIdChange (newValue: string) {
    if (newValue) {
      const el: any = document.getElementById(newValue)

      if (el !== null && el !== undefined) {
        this.$store.commit('fieldChoiceState/setChoosingFieldId', newValue)
        let areaId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        this.$emit('openSpecificAccordion', areaId.replace('areaId', ''))
        if (el) {
          el.scrollIntoView({ behavior: 'instant' })
        }
      } else {
        /* 圃場詳細が未取得の場合、対象のアコーディオンを疑似的に押下 */
        const allFieldData = this.$store.state.fieldState.fieldData
        let getFieldData = allFieldData.filter(function (data: any) {
          return (String(data.fieldId) === newValue)
        })
        if (getFieldData[0] !== undefined) {
          this.$emit('openSpecificAccordion', getFieldData[0].areaId)

          /* 一旦アコーディオンを一覧の一番上に移動 */
          const accordionEl: any = document.getElementById('areaId' + getFieldData[0].areaId)
          if (accordionEl !== null && accordionEl !== undefined) {
            accordionEl.scrollIntoView({ behavior: 'instant' })
          }
          this.$store.commit('fieldChoiceState/setChoosingFieldId', newValue)
          this.$store.commit('fieldChoiceState/setChooseFlag', true)
        }
      }
    }
  }
  @Watch('fieldDataState')
  private onDataChange (newValue: any) {
    this.displayFieldData = []
    this.changeData(newValue)
  }
  @Watch('props')
  private propsData (newValue: any) {
    this.displayFieldData = newValue
  }

  created () {
    let id:number = this.id
    this.displayFieldData = this.fieldData
  }

  mounted () {
    if (Session.getChoiceFieldId()!) {
      /* ひとつ前に選択していた圃場を開く */
      let id = Session.getChoiceFieldId()
      this.$store.commit('fieldChoiceState/setChoosingFieldId', id)
      let el: any = document.getElementById(String(id))
      if (el !== null && el !== undefined) {
        let areaId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        this.$emit('openSpecificAccordion', areaId.replace('areaId', ''))
      }
    }
  }

  private changeData (val: any) {
    let id:number = this.id
    this.displayFieldData = val.filter(function (data: any) {
      return (data.area_id === id)
    })
  }
}
